import { Dog, Fish, Package, Headphones } from "lucide-react";
import { IMG } from "@/lib/site";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import CtaSection from "@/components/CtaSection";

const punti = [
  { icon: Dog, t: "Prodotti per animali", d: "Accessori, guinzagli, collari, giochi, prodotti per la cura." },
  { icon: Fish, t: "Articoli per la pesca", d: "Attrezzature e accessori selezionati per gli appassionati." },
  { icon: Headphones, t: "Consulenza e assistenza", d: "Personale disponibile per aiutarti nella scelta." },
  { icon: Package, t: "Tutto in un solo luogo", d: "La comodità di trovare più servizi e prodotti insieme." },
];

export default function Negozio() {
  return (
    <div data-testid="page-negozio">
      <PageHero
        overline="Negozio per animali & pesca"
        title="Un punto di riferimento per prodotti e accessori"
        lead="Articoli per animali e attrezzature da pesca selezionate: tutto ciò che ti serve, in un unico luogo."
        image={IMG.negozio}
        primaryCta={{ to: "/contatti", label: "Contattaci" }}
        secondaryCta={{ to: "/cibo", label: "Cibo per cani" }}
      />

      <section className="py-16 sm:py-24" data-testid="animali">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal">
            <SectionHeading
              overline="Prodotti per animali"
              title="Tutto il necessario per la quotidianità."
            />
            <ul className="mt-7 space-y-3 text-[#6B5F4A]">
              {[
                "Accessori, guinzagli, collari e pettorine",
                "Prodotti per l'igiene e la cura del mantello",
                "Giochi, premi e oggetti per l'intrattenimento",
                "Cuccette, trasportini e ciotole",
                "Alimenti per cani e piccoli animali",
              ].map((p) => (
                <li key={p} className="flex gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#7A1F1F] flex-none" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-6 reveal">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={IMG.negozio} alt="Negozio per animali" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EDD895]/60" data-testid="pesca">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal order-2 lg:order-1">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={IMG.pesca} alt="Articoli per la pesca" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6 reveal order-1 lg:order-2">
            <SectionHeading
              overline="Articoli per la pesca"
              title="Per gli appassionati di ogni livello."
              lead="Una selezione di attrezzature, accessori e prodotti dedicati a chi vive la pesca con passione."
            />
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24" data-testid="vantaggi-negozio">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <SectionHeading overline="Perché venire da noi" title="Comodità, assistenza, qualità." />
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {punti.map((p, i) => (
              <div
                key={p.t}
                className="reveal bg-[#F5E6C0] border border-[#D9C48A] rounded-3xl p-7"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#EDD895] grid place-items-center mb-5 text-[#8B4A2B]">
                  <p.icon className="w-6 h-6" strokeWidth={1.4} />
                </div>
                <h4 className="font-sans font-semibold text-[#1A1710] text-lg">{p.t}</h4>
                <p className="mt-2 text-sm text-[#6B5F4A] leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Passa a trovarci"
        lead="Vieni in negozio: troverai tutto ciò che cerchi per il tuo animale e per la tua passione per la pesca."
        primaryLabel="Contattaci"
      />
    </div>
  );
}
